/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export enum PersonalizationTypeEnum {
    text = "text",
    image = "image",
    text_image = "text_image",
    visual_design = "visual_design"
}

export type PersonalizationType = PersonalizationTypeEnum;